import Test from "./TestPresenter";

const TestContainer = () => {

  return (
    <Test 
    />
  );
}

export default TestContainer;